import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { updatePageSEO, SEO_CONFIGS } from '../../utils/seo';

export default function BlogPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Update SEO
    updatePageSEO(SEO_CONFIGS.blog);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const blogPosts = [
    {
      id: 1,
      category: '入試情報',
      title: '2025年度 岡山県公立高校入試の変更点について',
      excerpt: '2025年度の岡山県公立高校入試において、いくつかの重要な変更点があります。岡山市北区の受験生と保護者様に向けて、詳しく解説します。',
      date: '2025年1月15日',
      image: 'https://public.readdy.ai/ai/img_res/1b1e3477df4622b0853518bc1c09193c.jpg'
    },
    {
      id: 2,
      category: '学習方法',
      title: '効果的な定期テスト対策：2週間前からの学習計画',
      excerpt: '岡山市北区の中学校の定期テストで高得点を取るための、2週間前からの効果的な学習計画をご紹介します。',
      date: '2025年1月10日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20student%20creating%20study%20schedule%20and%20planning%20test%20preparation%20organized%20learning%20materials%20simple%20clean%20background&width=800&height=600&seq=blog002&orientation=landscape'
    },
    {
      id: 3,
      category: '合格体験記',
      title: '岡山朝日高校合格！Aさんの体験談',
      excerpt: '岡山市北区在住のAさんが、おかやま学習塾での学習を通じて岡山朝日高校に合格した体験談をご紹介します。',
      date: '2025年1月5日',
      image: 'https://readdy.ai/api/search-image?query=happy%20Japanese%20student%20celebrating%20high%20school%20acceptance%20success%20with%20bright%20smile%20achievement%20moment%20simple%20clean%20background&width=800&height=600&seq=blog003&orientation=landscape'
    },
    {
      id: 4,
      category: '教育コラム',
      title: '中学受験を考える保護者様へ：岡山市北区の中学校選び',
      excerpt: '岡山市北区で中学受験を検討されている保護者様に向けて、学校選びのポイントと受験対策についてお伝えします。',
      date: '2024年12月28日',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/f4e2398bf0498bfed9c9b36c8c4b8b66.jpeg'
    },
    {
      id: 5,
      category: '塾からのお知らせ',
      title: '冬期講習の成果報告と春期講習のご案内',
      excerpt: '2024年度冬期講習の成果をご報告するとともに、2025年度春期講習の詳細をお知らせします。',
      date: '2024年12月25日',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/eab86d6b58de237072e6bb633b6caff4.jpeg'
    },
    {
      id: 6,
      category: '学習方法',
      title: '苦手科目を克服する3つのステップ',
      excerpt: '岡山市北区の生徒様からよく相談される「苦手科目の克服方法」について、具体的な3つのステップをご紹介します。',
      date: '2024年12月20日',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/f99964ca0d9d4b362ac130fb0e243110.jpeg'
    },
    {
      id: 7,
      category: '入試情報',
      title: '岡山大学の推薦入試対策：志望理由書の書き方',
      excerpt: '岡山大学を目指す高校生向けに、推薦入試で重要となる志望理由書の書き方のポイントを解説します。',
      date: '2024年12月15日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20high%20school%20student%20writing%20university%20application%20essay%20concentrated%20expression%20simple%20clean%20background&width=800&height=600&seq=blog007&orientation=landscape'
    },
    {
      id: 8,
      category: '合格体験記',
      title: '岡山城東高校合格！Bさんの1年間の軌跡',
      excerpt: '中学2年生の冬から通塾を始め、見事岡山城東高校に合格したBさんの1年間の学習の軌跡をご紹介します。',
      date: '2024年12月10日',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/375955e50c205a85e6901032f443b0f4.jpeg'
    },
    {
      id: 9,
      category: '教育コラム',
      title: '保護者様ができる受験生サポート5選',
      excerpt: '岡山市北区で受験を控えたお子様を持つ保護者様に向けて、家庭でできる効果的なサポート方法をご紹介します。',
      date: '2024年12月5日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20parent%20supporting%20student%20at%20home%20creating%20comfortable%20study%20environment%20warm%20family%20scene%20simple%20clean%20background&width=800&height=600&seq=blog009&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/80 backdrop-blur-md'}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="text-2xl font-bold text-[#2D7A4F]">
              おかやま学習塾
            </Link>
            
            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-[#2D7A4F] transition-colors text-base font-medium whitespace-nowrap">事業内容</Link>
              <Link to="/about" className="text-gray-700 hover:text-[#2D7A4F] transition-colors text-base font-medium whitespace-nowrap">会社概要</Link>
              <Link to="/careers" className="text-gray-700 hover:text-[#2D7A4F] transition-colors text-base font-medium whitespace-nowrap">求人情報</Link>
              <Link to="/blog" className="text-[#2D7A4F] hover:text-[#236038] transition-colors text-base font-medium whitespace-nowrap border-b-2 border-[#2D7A4F]">ブログ・新着情報</Link>
              <Link to="/trial" className="text-gray-700 hover:text-[#2D7A4F] transition-colors text-base font-medium whitespace-nowrap">体験申し込み</Link>
              <a href="https://line.me/R/ti/p/@okayamajuku" target="_blank" rel="noopener noreferrer" className="bg-[#2D7A4F] text-white px-6 py-2.5 rounded-full hover:bg-[#236038] transition-colors flex items-center space-x-2 text-base font-medium whitespace-nowrap">
                <i className="ri-line-fill text-lg"></i>
                <span>LINE相談</span>
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-[#2D7A4F] w-10 h-10 flex items-center justify-center"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200">
            <div className="px-6 py-4 space-y-4">
              <Link to="/services" className="block text-gray-700 hover:text-[#2D7A4F] transition-colors text-base font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>事業内容</Link>
              <Link to="/about" className="block text-gray-700 hover:text-[#2D7A4F] transition-colors text-base font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>会社概要</Link>
              <Link to="/careers" className="block text-gray-700 hover:text-[#2D7A4F] transition-colors text-base font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>求人情報</Link>
              <Link to="/blog" className="block text-[#2D7A4F] hover:text-[#236038] transition-colors text-base font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>ブログ・新着情報</Link>
              <Link to="/trial" className="block text-gray-700 hover:text-[#2D7A4F] transition-colors text-base font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>体験申し込み</Link>
              <a href="https://line.me/R/ti/p/@okayamajuku" target="_blank" rel="noopener noreferrer" className="block bg-[#2D7A4F] text-white px-6 py-3 rounded-full hover:bg-[#236038] transition-colors text-center text-base font-medium">
                <i className="ri-line-fill mr-2"></i>LINE相談
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative h-[40vh] min-h-[350px] sm:min-h-[400px] flex items-center justify-center pt-20">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/4502a60f6a6d0d5106754c5f89509f9d.jpeg" 
            alt="おかやま学習塾のブログ"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative z-10 text-center px-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6">
            ブログ・新着情報
          </h1>
          <div className="flex items-center justify-center space-x-3 text-white/90 text-sm">
            <Link to="/" className="hover:text-white transition-colors">ホーム</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span>ブログ・新着情報</span>
          </div>
        </div>
      </section>

      {/* Blog Posts Section */}
      <section className="py-16 sm:py-20 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
              最新の記事
            </h2>
            <p className="text-base sm:text-lg text-gray-600 px-4">
              岡山市北区の入試情報や<br className="sm:hidden" />学習のコツをお届けします
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article key={post.id} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer group">
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-[#2D7A4F] text-white px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="text-sm text-gray-500 mb-3 flex items-center">
                    <i className="ri-calendar-line mr-2"></i>
                    {post.date}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-[#2D7A4F] transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-base text-gray-600 leading-relaxed line-clamp-3 mb-4">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center text-[#2D7A4F] font-semibold group-hover:gap-2 transition-all">
                    <span>続きを読む</span>
                    <i className="ri-arrow-right-line text-xl"></i>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* Pagination */}
          <div className="mt-16 flex justify-center items-center space-x-2">
            <button className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#2D7A4F] hover:text-[#2D7A4F] transition-colors">
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <button className="w-10 h-10 rounded-full bg-[#2D7A4F] text-white flex items-center justify-center font-semibold">
              1
            </button>
            <button className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#2D7A4F] hover:text-[#2D7A4F] transition-colors font-semibold">
              2
            </button>
            <button className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#2D7A4F] hover:text-[#2D7A4F] transition-colors font-semibold">
              3
            </button>
            <button className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#2D7A4F] hover:text-[#2D7A4F] transition-colors">
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-16 sm:py-20 lg:py-32 bg-[#F1F8F4]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
              カテゴリー
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4">
            <button className="bg-white hover:bg-[#2D7A4F] hover:text-white text-gray-700 px-6 py-4 rounded-full transition-all font-semibold text-base shadow-md">
              入試情報
            </button>
            <button className="bg-white hover:bg-[#2D7A4F] hover:text-white text-gray-700 px-6 py-4 rounded-full transition-all font-semibold text-base shadow-md">
              学習方法
            </button>
            <button className="bg-white hover:bg-[#2D7A4F] hover:text-white text-gray-700 px-6 py-4 rounded-full transition-all font-semibold text-base shadow-md">
              合格体験記
            </button>
            <button className="bg-white hover:bg-[#2D7A4F] hover:text-white text-gray-700 px-6 py-4 rounded-full transition-all font-semibold text-base shadow-md">
              教育コラム
            </button>
            <button className="bg-white hover:bg-[#2D7A4F] hover:text-white text-gray-700 px-6 py-4 rounded-full transition-all font-semibold text-base shadow-md">
              塾からのお知らせ
            </button>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-20 lg:py-32 bg-[#A5D6A7]">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
            無料体験授業を<br className="sm:hidden" />受付中
          </h2>
          <p className="text-base text-gray-700 mb-8 sm:mb-10 px-4">
            岡山市北区で志望校合格を<br className="sm:hidden" />目指すなら、<br className="sm:hidden" />おかやま学習塾へ
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center px-4">
            <Link to="/trial" className="bg-[#2D7A4F] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full hover:bg-[#236038] transition-all text-base lg:text-lg font-semibold flex items-center justify-center space-x-2 shadow-lg whitespace-nowrap">
              <span>無料体験授業を申し込む</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
            <a href="tel:0860123456" className="bg-white text-[#2D7A4F] border-2 border-[#2D7A4F] px-6 sm:px-8 py-3 sm:py-4 rounded-full hover:bg-gray-50 transition-all text-base lg:text-lg font-semibold flex items-center justify-center space-x-2 whitespace-nowrap">
              <i className="ri-phone-fill text-xl"></i>
              <span>086-012-3456</span>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1B5E3F] text-white mx-6 lg:mx-8 my-8 rounded-3xl">
        <div className="max-w-7xl mx-auto px-8 lg:px-12 py-16">
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            <div>
              <h3 className="text-3xl lg:text-4xl font-light mb-6">お気軽にご相談ください</h3>
              <p className="text-base text-white/80 mb-8 leading-relaxed">
                岡山市北区で志望校合格を目指すなら、おかやま学習塾にお任せください。無料体験授業も随時受付中です。
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="tel:0860123456" className="text-white text-xl font-semibold hover:text-[#A5D6A7] transition-colors whitespace-nowrap flex items-center">
                  <i className="ri-phone-fill text-xl mr-2"></i>
                  <span>086-012-3456</span>
                </a>
                <a href="https://line.me/R/ti/p/@okayamajuku" target="_blank" rel="noopener noreferrer" className="bg-white text-[#1B5E3F] px-6 py-3 rounded-full hover:bg-white/90 transition-colors text-center font-semibold whitespace-nowrap">
                  <i className="ri-line-fill mr-2"></i>LINEで相談
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-base font-semibold mb-6 text-white/70">サイトマップ</h4>
              <ul className="space-y-4">
                <li><Link to="/services" className="text-base hover:text-[#A5D6A7] transition-colors underline">事業内容</Link></li>
                <li><Link to="/about" className="text-base hover:text-[#A5D6A7] transition-colors underline">会社概要</Link></li>
                <li><Link to="/careers" className="text-base hover:text-[#A5D6A7] transition-colors underline">求人情報</Link></li>
                <li><Link to="/blog" className="text-base hover:text-[#A5D6A7] transition-colors underline">ブログ・新着情報</Link></li>
                <li><Link to="/trial" className="text-base hover:text-[#A5D6A7] transition-colors underline">体験申し込み</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-base font-semibold mb-6 text-white/70">おかやま学習塾</h4>
              <p className="text-base text-white/80 mb-2">営業時間：15:00 〜 22:00</p>
              <p className="text-base text-white/80 mb-6">定休日：日曜日・祝日</p>
              <h4 className="text-base font-semibold mb-4 text-white/70">所在地</h4>
              <p className="text-base text-white/80">〒700-0000</p>
              <p className="text-base text-white/80">岡山市北区○○町1-2-3</p>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-white/70 text-sm">
              © 2025 おかやま学習塾 All Rights Reserved.
            </div>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-white/70 hover:text-white transition-colors underline">プライバシーポリシー</a>
              <a href="#" className="text-white/70 hover:text-white transition-colors underline">特定商取引法</a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors underline">Website Builder</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}